import React, {
  useContext,
  useEffect,
  useState,
  useMemo,
  useCallback,
} from "react";
import "./About.css";
import CustomBreadCrumb from "../../components/CustomBreadCrumb";
import axios from "axios";
import { API_BASE_URL, APIs } from "../../constants/Constants";
import axiosInterceptor from "../../helpers/Interceptor";
import loaderContext from "../../context/loader/LoaderContext";
import { isMobile } from "react-device-detect";
import themeContext from "../../context/theme/ThemeContext";
import { getEnv } from '../../helpers/EnvHelper';


const About = () => {

  const PRODUCT_VERSION = getEnv("REACT_APP_PRODUCT_VERSION");
  const RELEASE_DATE = getEnv("REACT_APP_RELEASE_DATE");

  const {ref, setLoaderRunning} = useContext(loaderContext);
  const { themeName} = useContext(themeContext);

  const breadCrumbItems = [
    {
      text: "About Us",
      key: "about_us",
    },
  ];

  useEffect(() => {
    document.title = "About Us";
  }, []);

  const handleDownload = async (event) => {
    event.preventDefault(); 
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
        const response = await axiosInterceptor.post(API_BASE_URL + APIs.DOWNLOADMANUAL, {
          withCredentials: true,
        });
        if (response.status === 200) {
            const decodedData = atob(response.data.data.byteArray);
            const arrayBuffer = new Uint8Array(decodedData.length);
            for (let i = 0; i < decodedData.length; i++) {
              arrayBuffer[i] = decodedData.charCodeAt(i);
            }
            const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);


            const a = document.createElement('a');
            a.href = url;
            a.download = response.data.data.filename; // Set the file name
            document.body.appendChild(a);
            a.click(); // Click the <a> element to trigger the download
            document.body.removeChild(a); // Clean up
            window.URL.revokeObjectURL(url); // Revoke the temporary URL
        }
        setLoaderRunning(false);
        ref.current.complete();
      } catch (error) {
        setLoaderRunning(false);
        ref.current.complete();
        if (error.response.status === 403)
          window.location.assign(APIs.REDIRECTLOGOUT);
        else return error.response;
      }
  }
  return (
    <>
    {/* <div className="main-container-body" style={{overflow:'auto'}}> */}
     <div className="custom-scroll study-list-filter-section" style={{ height: "calc(100vh - 55px)" }}>
        <div className="breadCrumb">
          <CustomBreadCrumb items={breadCrumbItems} />
        </div>
        <div className="row about-react-container" style={{flexDirection: isMobile?"column":"row"}}>
          <div className="col-md-6 col-12 about-react-section-1">
            
              <h4 className="version-number">Product Name: <span>Augmento</span></h4>
              <h4 className="version-number">Brand: <span>DeepTek</span></h4>
              <h4 className="version-number">Model: <span>DeepTek_001</span></h4> 
              <h4 style={{marginBottom: "15px"}} className="version-number">Product Version: <span>{PRODUCT_VERSION}</span></h4> 
              
              <p>
                <b style={{ fontSize: "17px" }}>Augmento</b> is a web based PACS
                and radiology workflow management solution. It receives digital
                images and data from various DICOM compliant sources (i.e. CT
                scanners, MR scanners, ultrasound systems, RF Units, PET Units,
                computed & digital radiographic devices, secondary capture
                devices, imaging gateways and other imaging sources). Images and
                data can be stored, communicated, processed, and displayed within
                the system and/or across computer networks at distributed
                locations.
              </p>
              <br />
              <p>
                Only pre-processed DICOM "for presentation" images can be
                interpreted for primary image diagnosis in mammography. Lossy
                compressed images and digitized film screens of mammographic
                images must not be reviewed for primary image interpretations.
                Mammographic images may only be interpreted using a monitor that
                meets technical specifications identified by the FDA, EU MDR and
                other applicable regulations.
              </p>
              <br />
              <p>
                This system is meant to be used by trained and qualified medical
                professionals, e.g. physicians, radiologists, nurses, and medical
                technicians.
              </p>
              <br />
              <p>
                Augmento provides the feature of optional integration with
                regulatory-cleared 3rd party AI models. The solution only provides
                support for the visualization of the output of 3rd party AI models
                "as-is". The safety and effectiveness of the 3rd party model is
                covered under the original 3rd party manufacturer's regulatory
                clearance. Augmento merely displays the simple output, and the
                original image is always accessible. It is the responsibility of
                qualified medical practitioners to review the AI output, confirm
                the findings and perform the diagnosis.
              </p>
              <br />
             <div
                  style={{ justifyContent: "start" }}
                  className="about-react-subsection-3"
                >
                  <div className="col-lg-12 medraplus-info">
                    <p>Authorized Importer in Philippines</p>
                    <p>Leemarc Drug Distribution Services</p>
                    <p className="medraplus-contact" style={{ marginTop: "5px" }}>
                      Blk 6 Lot 2 St. Agata Village 1, Santa Rosa City, Laguna
                    </p>
                    <p className="medraplus-contact">CMDR No.: CMDR-2025-04076</p>
                  </div>
                </div>
              <p style={{ fontSize: "15px", textAlign: "center", marginTop:"15px" }}>
                  {" "}
                  For any queries, please contact: &nbsp;
                  <a
                    href="mailto:support@deeptek.ai"
                    // style={{ color: "#95c3eb" }} old color
                    style={{ 
                      color: themeName === "light" ? "#002BFF" : "#95c3eb", 
                    }}
                    className="support-email"
                  >
                    support@deeptek.ai
                  </a>{" "}
              </p>
               
          </div>

            <div className="col-md-6 col-12 about-react-section-2">

              <div className="right-block">

                <div className="row logo-section">
                  <div className="row about-right">
                    <div className="about-react-manufacturer-content">
                      <div>
                        <img  src={`${window.location.origin}/images/ce-logo.png`} className="ce-logo" />
                      </div>
                      <div className="vertical-line"></div>
                      <div className="manufacturer-img">
                        <img
                          src={`${window.location.origin}/images/manufacturer_logo1.png`} 
                          className="about-react-manufacturer-logo"
                        />
                      </div>
                      <div className="about-react-manufacturer-details">
                        <p style={{ fontSize: "15px", marginBottom: "0px", fontWeight: "600" }}>
                          
                          DeepTek Medical Imaging Private Limited
                        </p>
                        <p style={{ fontSize: "10px", lineHeight:'15px' }}>
                          
                          3rd Floor, ldeas to Impact, Pallod Farms 3, Behind Vijay
                          Sales, <br />
                          Baner, Pune, Maharashtra 411045 India
                        </p>
                      </div>
                    </div>
                  </div>

                  <hr />
                  <div className="row about-right">
                    <div className="col-lg-7 four-logo-outer">
                        <div className="ec-rep-outer">
                          <img src={`${window.location.origin}/images/ec-rep.png`}  className="ec-rep-logo" alt="EC Rep Logo"/>
                        </div>
                        <div className="logo-details" style={{lineHeight:'14px'}}>
                          <p style={{ fontSize: '15px', marginBottom: '0px', fontWeight: 600 }}>Specculo Limited</p>
                          <p style={{ fontSize: '10px', marginBottom: '0px', marginTop: '2px' }}>10/1, Sir M.A. Refalo Ave Balzan,<br/>
                           BZN 1600, Malta</p>
                      </div>
                    </div>
                    <div  className="col-lg-5 four-logo-outer" style={{marginLeft:'80px'}}>
                      <img src={`${window.location.origin}/images/info-icon.png`} className="about-react-logo"/>
                      <div className="logo-details">
                      {/* <a href="#" onClick={handleDownload}  style={{color: "#418ED2", fontSize: '15px' }} className="support-email">eIFU</a>  old color*/}
                        <a href="#" onClick={handleDownload}  style={{color: "#0000FF", fontSize: '15px' }} className="support-email">eIFU</a>
                      </div>
                    </div>
                  </div>
                  <div className="row about-right">
                       <div className="col-lg-7 four-logo-outer" style={{marginLeft:'43px'}}>
                          <img
                              src={`${window.location.origin}/images/udi-icon.png`}
                              className="about-react-logo"
                            />
                          <div className="logo-details">
                            <p style={{ fontSize: '10px', marginBottom: '0px', fontWeight: 600 }}>(01)8908023670007(11)260114(10)3.2.97</p>
                          </div>
                      </div>
                      <div  className="col-lg-5 four-logo-outer" style={{marginLeft:'37px'}}>
                        <img
                            src={`${window.location.origin}/images/md-icon.png`}
                            className="about-react-logo"
                          />
                      </div>
                  </div>
                  <hr/>
                  <div class="row relase-date">
                    <img
                          src={`${window.location.origin}/images/release-logo.png`}
                          className="about-react-logo"
                          style={{ height: '32px', width: 'auto' }}
                        />
                      <p style={{ marginLeft: '10px', fontSize: '10px', marginBottom: '0px' }}><span>{RELEASE_DATE}</span></p>
                  </div>
                </div>

                <div
                  style={{ justifyContent: "start" }}
                  className="about-react-subsection-3"
                >
                  <div className="col-lg-12 medraplus-info">
                    <p>Authorized Representative (AR) in Malaysia</p>
                    <p>Medraplus sdn.bhd (1502649-X)</p>
                    <p className="medraplus-contact" style={{ marginTop: "5px" }}>
                      No. 29-5 Menara 1 Mont Kiara, No.1 Jalan Kiara, Mont Kiara,
                      50480, Kuala Lumpur
                    </p>
                    <p className="medraplus-contact">Ph no: 6011-39087001</p>
                    <p className="medraplus-contact">
                      Email:
                      <a
                        href="mailto:regulatory@medraplus.com"
                        // style={{ color: "#95c3eb", marginLeft: "3px" }}  
                        style={{ 
                            color: themeName === "light" ? "#002BFF" : "#95c3eb", 
                            marginLeft: "3px" 
                        }}
                        className="support-email"
                      >
                        regulatory@medraplus.com
                      </a>
                    </p>
                    <p className="medraplus-contact">
                      MDA registration number: MDR-20231218-87104
                    </p>
                  </div>
                </div>
                {/* South Africa AR */}
                <div
                  style={{ justifyContent: "start" }}
                  className="about-react-subsection-3"
                >
                  <div className="col-lg-12 medraplus-info">
                    <p>Authorized Representative (AR) in South Africa</p>
                    <p>Freyr Solutions (Pty) Ltd</p>
                    <p className="medraplus-contact" style={{ marginTop: "5px" }}>
                      34 Monkor Road, Randpark Ridge
                    </p>
                    <p className="medraplus-contact">Randburg, Gauteng 2194</p>
                    <p className="medraplus-contact">Registration Number: XXXX</p>
                  </div>
                </div>
                {/* Philippines Importer */}
                {/* <div
                  style={{ justifyContent: "start" }}
                  className="about-react-subsection-3"
                >
                  <div className="col-lg-12 medraplus-info">
                    <p>Authorized Importer in Philippines</p>
                    <p>Leemarc Drug Distribution Services</p>
                    <p className="medraplus-contact" style={{ marginTop: "5px" }}>
                      Blk 6 Lot 2 St. Agata Village 1, Santa Rosa City, Laguna
                    </p>
                    <p className="medraplus-contact">CMDR No.: CMDR-XXXX</p>
                  </div>
                </div> */}

                <div
                  style={{ justifyContent: "start" }}
                  className="about-react-subsection-3"
                >
                  <div className="col-lg-12 medraplus-info">
                    <p>Authorized Importer in Indonesia</p>
                    <p>Distributed and Imported by</p>
                    <p>PT. Tritra Prima Indonesia</p>
                    <p className="medraplus-contact" style={{ marginTop: "5px" }}>Bekasi-Indonesia</p>
                    <p className="medraplus-contact">Registration No.: KEMENKES RI AKL 21501420560</p>
                  </div>
                </div>
              


              </div>
            </div>
          
        </div>
      </div>
    </>
  );
};

export default About;
